export const APP_URL = "https://watiseeratest.transfoafricainc.com:8000/api/";

//export const APP_URL = "http://localhost:8000/api/";
